<form [formGroup]="parentFormGroup">
  <div class=" bold margin-right">
    {{mappedKeyWord.name}}:
  </div>
  <div>
    @if (mappedKeyWord.dropdownValues && mappedKeyWord.dropdownValues.length > 0) {
      <div>
        <ng-select id={{mappedKeyWord.name}} formControlName={{mappedKeyWord.name}} [multiple]="mappedKeyWord.allowMultiSelect" [items]="mappedKeyWord.dropdownValues" bindLabel="value" bindValue="value" placeholder=""
        (blur)="onBlur()"></ng-select>
      </div>
    }
    @if (mappedKeyWord.dataType === 'AlphaNumeric' && (!mappedKeyWord.dropdownValues || mappedKeyWord.dropdownValues.length == 0)) {
      <div>
        <input id={{mappedKeyWord.name}} type="text" formControlName={{mappedKeyWord.name}} [attr.maxLength]="mappedKeyWord.dataLength" [attr.disabled]="isDisabled ? 'disabled' : null" (blur)="onBlur()"/>
      </div>
    }
    @if (mappedKeyWord.dataType === 'FloatingPoint' && (!mappedKeyWord.dropdownValues || mappedKeyWord.dropdownValues.length == 0)) {
      <div>
        <input type="number" formControlName={{mappedKeyWord.name}} [attr.maxLength]="mappedKeyWord.dataLength" [attr.disabled]="isDisabled  ? 'disabled' : null" (blur)="onBlur()">
      </div>
    }
    @if ((mappedKeyWord.dataType === 'Numeric20' || mappedKeyWord.dataType === 'Numeric9') && (!mappedKeyWord.dropdownValues || mappedKeyWord.dropdownValues.length == 0)) {
      <div>
        <input type="number" formControlName={{mappedKeyWord.name}} [attr.maxLength]="mappedKeyWord.dataLength" [attr.disabled]="isDisabled ? 'disabled' : null"
          oninput="this.value = Math.round(this.value);" min="0" step="1" (blur)="onBlur()">
        </div>
      }
      @if ((mappedKeyWord.dataType === 'Date' || mappedKeyWord.dataType === 'DateTime') && (!mappedKeyWord.dropdownValues || mappedKeyWord.dropdownValues.length == 0)) {
        <div>
          <common-date-picker [id]="mappedKeyWord.name" [controlName]="mappedKeyWord.name" [disabled]="isDisabled" (controlUpdated)="dateCtrlUpdated($event)"></common-date-picker>
        </div>
      }
      @if (mappedKeyWord.dataType === 'Currency' && (!mappedKeyWord.dropdownValues || mappedKeyWord.dropdownValues.length == 0)) {
        <div>
          <input id={{mappedKeyWord.name}} type="number" min="0.01" step="0.01" formControlName={{mappedKeyWord.name}} [attr.maxLength]="mappedKeyWord.dataLength"
            [attr.disabled]="isDisabled  ? 'disabled' : null" (blur)="onBlur()"/>
          </div>
        }
      </div>
      @if (parentFormGroup.get(mappedKeyWord.name).invalid) {
        <div class="error-container">
          @if (parentFormGroup.get(mappedKeyWord.name).invalid) {
            <small class="error">
              The current keyword value is invalid.
            </small>
          }
        </div>
      }
    </form>
